import React, { forwardRef } from 'react';

import classNames from 'classnames';

import * as classes from './style.module.scss';
import { CodeLineProps } from './types';

const CodeBlockLine = forwardRef<HTMLDivElement, CodeLineProps>(
  (
    {
      index,
      line,
      file,
      allowHighlighting = false,
      getLineProps,
      getTokenProps,
      className,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        key={index}
        {...getLineProps({ line, key: index })}
        data-number={index + 1}
        data-file={file}
        data-allow-highlighting={allowHighlighting}
        className={classNames(classes.root, className)}
      >
        <span>
          {line.map((token, key) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={`${file}-${key}-line`}
              {...getTokenProps({ token, key })}
            />
          ))}
        </span>
      </div>
    );
  },
);

CodeBlockLine.displayName = 'CodeBlockLine';

export { CodeBlockLine };
